export type ProgramLanguageType =
  | 'C'
  | 'C++'
  | 'C++11'
  | 'C++14'
  | 'C++17'
  | 'C++20'
  | 'C++23'
  | 'C++20'
  | 'C++23'
  | 'JAVA'
  | 'D'
  | 'C#'
  | 'Scala'
  | 'Python'
  | 'Python3'
  | 'PyPy3'
  | 'Ruby'
  | 'JavaScript'
  | 'Rust'
  | 'Go'
  | 'Kotlin'
  | 'PHP'
  | 'Haskell'
  | 'OCaml'

export const programLanguageList: ProgramLanguageType[] = [
  'C',
  'C++',
  'C++11',
  'C++14',
  'C++17',
  'C++20',
  'C++23',
  'JAVA',
  'D',
  'C#',
  'Scala',
  'Python',
  'Python3',
  'PyPy3',
  'Ruby',
  'JavaScript',
  'Rust',
  'Go',
  'Kotlin',
  'PHP',
  'Haskell',
  'OCaml'
]

export type ProgramLanguageInfo = {
  name: ProgramLanguageType
  suffix: string
  code: string
}
